/**
 * @file
 * HSL Carousel Texto e Imagem - Swiper initialization.
 */

(function (Drupal, once) {
  Drupal.behaviors.hslCarouselTextoImagem = {
    attach(context) {
      once(
        "hslCarouselTextoImagem",
        ".hsl-carousel-texto-imagem",
        context
      ).forEach((el) => {
        const Swp = window.Swiper;
        if (!Swp) {
          return;
        }

        const container = el.querySelector(".swiper");
        const wrapper = el.querySelector(".swiper-wrapper");
        if (!container || !wrapper) {
          return;
        }

        const slidesCount = wrapper.children.length;
        const hasMultiple = slidesCount > 1;

        const paginationEl = el.querySelector(".swiper-pagination");

        const options = {
          loop: hasMultiple,
          speed: 400,
          autoplay: { delay: 5000 },
          navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev"),
          },
          a11y: { enabled: true },
          watchOverflow: true,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
                bulletClass: "hsl-carousel-texto-imagem__bullet",
                bulletActiveClass: "hsl-carousel-texto-imagem__bullet--active",
              }
            : false,
        };

        /* eslint-disable-next-line no-new */
        const swiper = new Swp(container, options);

        if (!hasMultiple) {
          el.querySelectorAll(
            ".swiper-button-next, .swiper-button-prev, .swiper-pagination"
          ).forEach((ctrl) => {
            if (ctrl) {
              ctrl.setAttribute("hidden", "hidden");
            }
          });
        }
      });
    },
  };
})(Drupal, once);
